import React,{useState} from "react";
import { Segment, Dropdown } from "semantic-ui-react";
import BusinessclientFilter from "../../Filters/BusinessclientFilter";
import WarehouseFilter from "../../Filters/WarehouseFilter";

const optionsDaysSelect = [7, 14, 30].map((nr) => ({
  key: nr,
  value: nr,
  text: `${nr} days`,
}));

function Filters({ days, setDays,setWarehouse,setClient }) {

  

  return (
    <Segment>
      <div className="flex--between">
        <div className="flex--left">
          <WarehouseFilter
            useFilter={false}
            handleChange={(value) => setWarehouse(value)}
          ></WarehouseFilter>

          <BusinessclientFilter
            useFilter={false}
            handleChange={(value) => setClient(value)}
          />
        </div>
        <Dropdown
          selectOnBlur={false}
          closeOnChange={true}
          compact
          selection={true}
          name="days"
          value={days}
          onChange={(e, { value }) => setDays(value)}
          options={optionsDaysSelect}
          style={{ marginLeft: "10px" }}
        />
      </div>
    </Segment>
  );
}

export default Filters;
